import { CubeTimeDimensionGranularity, Weekdays } from "../../../enum/cube-schema.enum";
import { CubeConfigDto } from "../../common/request/cube-config.dto";

export interface QueryPerWeekdayAverageScoresRequestParamsDto {
    startDate: string;
    endDate: string;
    timezone?: string;
    granularity?: CubeTimeDimensionGranularity;
    weekday?: Weekdays;
}